import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCreateEvent } from '../../../hooks/useEvents';
import { useToast } from '../../../hooks/useToast';
import EventForm from '../../../components/forms/EventForm';

const EventCreate = () => {
  const navigate = useNavigate();
  const createEvent = useCreateEvent();
  const toast = useToast();

  const handleSubmit = async (data) => {
    try {
      await createEvent.mutateAsync(data);
      toast.success('Evento criado com sucesso!');
      navigate('/admin/calendario');
    } catch (error) {
      toast.error('Erro ao criar evento: ' + error.message);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/admin/calendario')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar para lista
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Novo Evento</h1>
        <p className="text-gray-600 mt-1">
          Cadastre um evento no calendário da associação
        </p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <EventForm onSubmit={handleSubmit} isLoading={createEvent.isPending} />
      </div>
    </div>
  );
};

export default EventCreate;
